<template>
  <div class="sub_content col-12 mt-2">
    <ValidationObserver ref="observer" v-slot="{ passes }">
      <b-form @submit.prevent="passes(onSubmit);" @reset="resetForm">
        <div class="row">
          <DataListWithValidation
            rules="required"
            type="text"
            label="회사명"
            name="form.name"
            size="sm"
            class="col-6 d-inline-block"
            v-model="form.name"
            :options="companyOption"
            @dataChanged="dataChanged"
            description=""
            placeholder="회사명를 입력해주세요."
            autocomplete="off"
          />

          <InputWithValidation
            rules="required"
            type="text"
            label="지점명"
            title="지점명"
            name="form.sname"
            size="sm"
            class="col-6 d-inline-block"
            v-model="form.sname"
            description=""
            placeholder="지점명을 입력해주세요."
            autocomplete="off"
          />
        </div>

        <div class="row">
          <InputWithValidation
            rules="required|min:6"
            type="text"
            label="전화번호1"
            title="전화번호1"
            name="form.tel1"
            size="sm"
            class="col-6 d-inline-block"
            v-model="form.tel1"
            description=""
            placeholder="회사 연락처를 입력해주세요."
          />
          <InputWithValidation
            rules="required|min:6"
            type="text"
            label="전화번호2"
            title="전화번호2"
            name="form.tel2"
            size="sm"
            class="col-6 d-inline-block"
            v-model="form.tel2"
            description=""
            placeholder="회사 연락처를 입력해주세요."
          />
        </div>

        <div class="row">
          <InputWithValidation
            rules="required|min:2"
            type="text"
            label="담당자 이름"
            title="담당자 이름"
            name="form.manager_name"
            size="sm"
            class="col-6 d-inline-block"
            v-model="form.manager_name"
            description=""
            placeholder="담당자 이름을 입력해주세요."
          />
          <InputWithValidation
            rules="required|min:6"
            type="text"
            label="담당자 연락처"
            title="담당자 연락처"
            name="form.manager_tel"
            size="sm"
            class="col-6 d-inline-block"
            v-model="form.manager_tel"
            description=""
            placeholder="담당자 연락처를 입력해주세요."
          />
        </div>
        <hr/>
        <div class="float-right">
          <b-button type="reset" size="sm" variant="danger" class="mr-2">다시쓰기</b-button>
          <b-button type="submit" size="sm" variant="primary" class="mr-2">저장</b-button>
          <b-button type="button" size="sm" variant="dark" v-on:click="cancel">취소</b-button>
        </div>
      </b-form>
    </ValidationObserver>
  </div>
</template>

<script>
import _ from 'lodash'
import { ValidationObserver } from 'vee-validate'
import InputWithValidation from '@/components/common/validations/inputbox'
import DataListWithValidation from '@/components/common/validations/datalist'
import { phoneNumber } from '@/mixin/phoneNumber'
import ax from '@/api/company'

export default {
  name: 'CompanyView',
  components: {
    ValidationObserver,
    InputWithValidation,
    DataListWithValidation
  },
  mixins: [phoneNumber],
  data () {
    return {
      form_: {
        name: '',
        sname: '',
        tel1: '',
        tel2: '',
        manager_name: '',
        manager_tel: '',
      },
      form: {},
      companyOption: []
    }
  },
  created () {
    this.form = _.cloneDeep(this.form_)
  },
  mounted () {
    ax.mCompanys(response => {
      this.companyOption = response
    })
    if (this.$route.params.seq) {
      ax.get(this.$route.params.seq, response => {
        this.form = response
      })
    }
  },
  watch: {
    'form.tel1': function () {
      this.form.tel1 = this.phoneNumberMask(this.form.tel1)
    },
    'form.tel2': function () {
      this.form.tel2 = this.phoneNumberMask(this.form.tel2)
    },
    'form.manager_tel': function () {
      this.form.manager_tel = this.phoneNumberMask(this.form.manager_tel)
    }
  },
  methods: {
    onSubmit () {
      ax.save(this.$route.params.seq || null, this.form, (code, msg) => {
        this.$notify({
          group: 'alert',
          type: 'info',
          title: '정보',
          text: msg
        })
        if (code === 200) {
          this.$router.push({ path: '/company', query: this.$route.query })
        }
      })
    },
    resetForm () {
      this.form = _.cloneDeep(this.form_)
      requestAnimationFrame(() => {
        this.$refs.observer.reset()
      })
    },
    cancel () {
      this.$router.push({ path: '/company', query: this.$route.query })
    },
    dataChanged (v) {
      this.form.name = v.text
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
